import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { frontendDomains } from "js/utils/getBackendUrl";

import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
import { envConfig } from "@/config";
import { useUserSessionStore } from "stores/v2/userSessionStore";

type TEnv = "AU" | "US" | "UK" | "STG" | "SIT" | "UNKNOWN";

function getEnv(): TEnv {
	if (frontendDomains.ause1.includes(window.location.hostname)) {
		return "AU";
	} else if (frontendDomains.usce1.includes(window.location.hostname)) {
		return "US";
	} else if (frontendDomains.euwe2.includes(window.location.hostname)) {
		return "UK";
	} else if (frontendDomains.stg.includes(window.location.hostname)) {
		return "STG";
	} else if (frontendDomains.sit.includes(window.location.hostname)) {
		return "SIT";
	} else {
		return "UNKNOWN";
	}
}

export function datadogLogsInit(): void {
	console.log("envConfig.DATADOG_LOGGER_SESSION_SAMPLE_RATE", envConfig.DATADOG_LOGGER_SESSION_SAMPLE_RATE);
	datadogLogs.init({
		clientToken: envConfig.DATADOG_CLIENT_TOKEN,
		site: envConfig.DATADOG_URL,
		forwardErrorsToLogs: true,
		sessionSampleRate: envConfig.DATADOG_LOGGER_SESSION_SAMPLE_RATE,
		service: envConfig.DATADOG_LOGGER_SERVICE_NAME,
		env: getEnv(),
		version: envConfig.BUILD_VERSION,

		// before the log is sent to Datadog, add contextual info to it
		beforeSend: (log) => {
			log.view._applianceId = useUserSessionStore.getState().getActiveDevice();
			log.view._teacherUsername = useUserSessionStore.getState().getActiveUser();

			if (useSelectedClassroomStore.getState().id) {
				log.view._activeClassroomId = useSelectedClassroomStore.getState().id;
				log.view._activeClassroomName = useSelectedClassroomStore.getState().name;
			}
		},
	});
}

export function initDatadogRum(): void {
	const env = getEnv();
	const logsEnabledRegion = env === "AU" || env === "US" || env === "UK" || env === "STG";
	const rumEnabledRegion = env === "AU" || env === "US" || env === "UK";

	// check if we're running in production and Datadog RUM is enabled
	if (rumEnabledRegion && envConfig.DATADOG_RUM_ENABLED) {
		datadogRum.init({
			site: envConfig.DATADOG_URL,
			service: envConfig.DATADOG_RUM_SERVICE_NAME,
			env: "production",
			sampleRate: envConfig.DATADOG_RUM_SAMPLE_RATE,
			trackInteractions: true,
			version: envConfig.BUILD_VERSION,
			applicationId: envConfig.DATADOG_RUM_APP_ID,
			clientToken: envConfig.DATADOG_CLIENT_TOKEN,
		});
	}

	// check if we're running in production and Datadog Logging is enabled
	if (logsEnabledRegion && envConfig.DATADOG_LOGGING_ENABLED) {
		datadogLogsInit();
	}
}
